'use client'

import {camelCase} from 'lodash'
import {lazy, Suspense} from 'react'
import {wysiwygComponentVariants} from '../../_utils/variants'
import {type WysiwygEmbedFragment} from './_generated/fragment.graphql'
import type {HgEmbedProps} from '~/design-system/hg/components/HgEmbed'
type DatoWYSIWYGEmbedProps = WysiwygEmbedFragment

// Embed component uses heavy libraries, so we lazy load it
const HgArticleWYSIWYGEmbed = lazy(
  async () =>
    await import(
      '~/design-system/hg/components/HgWYSIWYG/Article/_components/HgEmbed'
    )
)

export const DatoWYSIWYGEmbed = ({url, source, height}: DatoWYSIWYGEmbedProps) => {
  const {embed} = wysiwygComponentVariants()
  return (
    <Suspense fallback={null}>
      <HgArticleWYSIWYGEmbed
        url={url}
        source={camelCase(source) as HgEmbedProps['source']}
        height={height ?? undefined}
        className={embed()}
      />
    </Suspense>
  )
}
